import { http } from "./http";
import {
  FindPaymentStatusResponse,
  GeneratePaymentLinkRequest,
  GeneratePaymentLinkResponse,
  PaymentCheckoutRequest,
  PaymentCheckoutResponse,
} from "@/types/api/payment";

export async function paymentCheckout(req: PaymentCheckoutRequest): Promise<PaymentCheckoutResponse> {
  return http.post<PaymentCheckoutResponse>("/api/payment/checkout", req);
}

export async function generatePaymentLink(req: GeneratePaymentLinkRequest): Promise<GeneratePaymentLinkResponse> {
  return http.post<GeneratePaymentLinkResponse>("/api/payment/new-payment-link", req);
}

export async function findPaymentStatus(paymentId: number): Promise<FindPaymentStatusResponse> {
  return http.get<FindPaymentStatusResponse>(`/api/payment/${paymentId}/status`);
}
